var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20833 8.32292C9.07375 8.32292 8.93917 8.27333 8.83292 8.16708C8.6275 7.96167 8.6275 7.62167 8.83292 7.41625L14.6413 1.60792C14.8467 1.4025 15.1867 1.4025 15.3921 1.60792C15.5975 1.81333 15.5975 2.15333 15.3921 2.35875L9.58375 8.16708C9.4775 8.27333 9.34292 8.32292 9.20833 8.32292Z",
    fill: "#7B1FA2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5833 5.34792C15.2929 5.34792 15.0521 5.10708 15.0521 4.81667V1.94792H12.1833C11.8929 1.94792 11.6521 1.70708 11.6521 1.41667C11.6521 1.12625 11.8929 0.885417 12.1833 0.885417H15.5833C15.8738 0.885417 16.1146 1.12625 16.1146 1.41667V4.81667C16.1146 5.10708 15.8738 5.34792 15.5833 5.34792Z",
    fill: "#7B1FA2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 16.1146H6.375C2.52875 16.1146 0.885417 14.4713 0.885417 10.625V6.375C0.885417 2.52875 2.52875 0.885417 6.375 0.885417H7.79167C8.08208 0.885417 8.32292 1.12625 8.32292 1.41667C8.32292 1.70708 8.08208 1.94792 7.79167 1.94792H6.375C3.10958 1.94792 1.94792 3.10958 1.94792 6.375V10.625C1.94792 13.8904 3.10958 15.0521 6.375 15.0521H10.625C13.8904 15.0521 15.0521 13.8904 15.0521 10.625V9.20833C15.0521 8.91792 15.2929 8.67708 15.5833 8.67708C15.8738 8.67708 16.1146 8.91792 16.1146 9.20833V10.625C16.1146 14.4713 14.4713 16.1146 10.625 16.1146Z",
    fill: "#7B1FA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.e7b0d7e5aad8eb3fcc177420fc03db8c.svg";
export { ForwardRef as ReactComponent };